<template>
    <div
        class="scan-ticket"
        :style="{
            'background-image': 'url(' + require(`@/public/img/${$store.state.config.skin}/bg.png`) + ')',
            'min-height': height,
        }"
    >
        <div class="scan-ticket__toggle-switch" v-if="games.length > 1">
            <template v-for="(item, index) in games" :key="index">
                <input class="scan-ticket__toggle-switch-input" type="radio" :id="item.code" :value="item.code" v-model="ticketType" name="toggle" />
                <label class="scan-ticket__toggle-switch-label" :for="item.code" :class="{ active: ticketType === item.code }">
                    {{ getTranslatedText(item.name) }}
                </label>
            </template>

            <span class="scan-ticket__toggle-switch-glider"></span>
        </div>
        <div class="scan-ticket__card">
            <div class="scan-ticket__box">
                <span class="scan-ticket__box__input-left-addon">{{ ticketType }} -</span>
                <div class="scan-ticket__box__input-box">
                    <span class="scan-ticket__box__input-box-label">{{ getTranslatedText('Code Ticket') }}</span>
                    <input class="scan-ticket__box__input-box-input" v-model="ticketNumber" type="text" autofocus />
                </div>
            </div>
            <div class="scan-ticket__card__box-button">
                <ButtonCommon
                    v-if="!isShowScan"
                    :type="configPage?.typeBtnSearch || 'primary'"
                    :isLoading="isLoadingButton"
                    :isDisable="ticketNumber === ''"
                    :className="['w100', { active: ticketNumber }]"
                    value="search"
                    icon="search"
                    @on-click-button-common="onSearchTicketDetail"
                />
                <span v-if="!isShowScan" class="scan-ticket__card__text-or"> - {{ getTranslatedText('or') }} - </span>
                <div class="scan-ticket__card__footer-button">
                    <ButtonCommon
                        className="w100"
                        :isLoading="isLoadingButton"
                        :type="configPage?.typeBtnScan || 'active'"
                        :value="isShowScan ? 'close ticket' : 'scan ticket'"
                        @on-click-button-common="onIsShowScan"
                    />
                    <template v-if="!config.isOnlyPaument && isShowRepay">
                        <ButtonCommon
                            v-if="!isShowScan"
                            :type="configPage?.typeBtnReplay || 'primary'"
                            :isLoading="isLoadingButton"
                            :isDisable="ticketNumber === ''"
                            className="w100 button-replay"
                            value="Replay"
                            icon="replay"
                            @on-click-button-common="handleRebet"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus';
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import checkGamne from '@/mixins/check-game';
import ButtonCommon from '@/components/common/button/button.vue';
import BetslipsService from '@/services/betslip/betslip.service.ts';
import printMixins from '@/mixins/print-mixins';

import { isObjEmpty, isArrayEmpty, generateCombinations } from '@/utils/utils';
import LottoService from '@/services/loto/loto.service';

export default {
    mixins: [languageMixins, utilsMixin, checkGamne, printMixins],
    components: { ButtonCommon },
    props: {
        config: {
            type: Object,
        },
    },
    data() {
        return {
            ticketType: '',
            ticketNumber: '',
            isShowTrue: false,
            isShowScan: false,
            idTimeOut: null,
            isLoadingButton: false,
            games: [],
            isShowRepay: false,
            configPage: null,
            height: '',
            choice: 'sports',
        };
    },
    watch: {
        ticketType(newValue, oldValue) {
            if (this.isShowScan) {
                this.isShowScan = false;
                this.isShowRepay = newValue != 'N';
                return;
            }

            if (newValue !== oldValue) {
                this.ticketNumber = '';
                this.isShowRepay = newValue != 'N';
            }
        },
    },
    mounted() {
        document.addEventListener('message', this.onDecode);
        this.setHeight();
    },
    created() {
        const index = this.$store.state.config.features.findIndex((x) => x.name === 'scan');

        if (index !== -1) this.configPage = this.$store.state.config.features[index];

        this.intitData();
        window.addEventListener('resize', this.setHeight);
    },

    methods: {
        setHeight() {
            const nav = document.getElementById('navigation');

            let height = nav?.clientHeight;
            height = window.innerHeight - height;

            this.height = `${height}px`;
        },

        intitData() {
            const games = this.checkGameEnable();
            this.games = games;
            this.ticketType = games[0].code;
            this.isShowRepay = this.ticketType != 'N';
        },

        async onSearchTicketDetail() {
            try {
                if (!this.isStrEmpty(this.ticketNumber)) {
                    const param = await this.validateGetTicket();
                    if (!this.isObjEmpty(param.response)) {
                        const { response, ticket } = param;

                        if (response.code !== 200) {
                            this.showNotification(response.message, 'error');
                            this.isLoadingButton = false;
                        } else {
                            const payload = {
                                data: response.data,
                                ticketId: ticket,
                                ticketType: this.ticketType,
                            };
                            EventBus.emit('on-show-ticket-detail', payload);
                            this.isLoadingButton = false;
                            this.ticketNumber = '';
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                this.isLoadingButton = false;
            }
        },

        showNotification(text, type) {
            const param = {
                text: text,
                type: type,
            };
            EventBus.emit('show-notications', param);
        },

        onIsShowScan() {
            this.isShowScan = !this.isShowScan;
            parent.postMessage({ command: 'is-show-cammera', param: this.isShowScan }, '*');
        },

        handleRebet() {
            switch (this.ticketType) {
                case 'S':
                    this.onRebetSports();
                    break;
                case 'L':
                    this.onRebetTicket();
                    break;
                default:
                    break;
            }
        },

        // action rebet
        async onTransactLotto(reference) {
            try {
                const respRebet = await BetslipsService.reBetTickets(reference);

                if ((respRebet.code === 200 || respRebet.status === 'success') && !isArrayEmpty(respRebet.data.bets?.entries)) {
                    const payload = [];
                    respRebet.data.bets.entries.map((x) => {
                        let item = {
                            slug: x.game.game,
                            price: x.entry.wager,
                            draws: 1,
                            event_id: [x.rebet.eventId],
                            selection: x.entry.bet,
                        };

                        payload.push(item);
                    });

                    const resp = await LottoService.transactLotto({ data: payload, isRebet: true });
                    if (resp.status === 'success') {
                        const data = resp.data;
                        let dataPrint = {};
                        dataPrint['total_tickets'] = 0;
                        const tickets = data.bets.entries.map((element) => {
                            const item = {
                                game_name: element.game.game,
                                selection_bet: element.entry.bet,
                                wager: element.entry.wager,
                                loto_name: this.getTranslatedText(this.$store.state.tabActive),
                                draw_date: this.renderDate(element.event.drawDate, true),
                            };

                            dataPrint.total_tickets += parseFloat(element.entry.wager);

                            return item;
                        });

                        dataPrint['title'] = this.getTranslatedText(this.$store.state.tabActive);
                        dataPrint['currency'] = data.transaction.currency;
                        dataPrint['id'] = data.transaction.transaction_id;
                        dataPrint['tickets'] = tickets;

                        this.printLoto(dataPrint);
                    } else {
                        this.showNotification(resp.message, 'warning');
                    }
                } else {
                    const message = respRebet.code === 200 ? respRebet.data.message : respRebet.message;
                    this.showNotification(message, 'error');
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoadingButton = false;
            }
        },

        async onTransactLottoDaily(reference) {
            try {
                const respToken = await LottoService.getTokenDaily();
                if (respToken.code === 200 || respToken.status === 'success') {
                    const respRebet = await BetslipsService.reBetDailyTickets(reference, respToken.data.token);
                    if ((respRebet.code === 200 || respRebet.status === 'success') && !isArrayEmpty(respRebet.data.bets?.entries)) {
                        const respGame = await LottoService.getDailyGames();
                        if (respGame.code === 200 && !isArrayEmpty(respGame.data)) {
                            const gameList = respGame.data;

                            let bets = {
                                entries: [],
                            };
                            respRebet.data.bets.entries.map((x) => {
                                const gameIndex = gameList.findIndex((item) => item.game.game_id === x.game.gameId);
                                if (gameIndex !== -1) {
                                    const gameItem = gameList[gameIndex];
                                    const marketIndex = gameItem.markets.findIndex((item) => item.market_id === x.market.marketId);
                                    const marketItem = gameItem.markets[marketIndex];

                                    const pickMin = marketItem.market_config.balls['1']?.picks[0];

                                    const combinations = generateCombinations(x.entry.bet[0].length, pickMin);
                                    const wager = parseFloat(x.entry.wager) / combinations;
                                    let item = {
                                        game: gameItem.game.slug,
                                        market: marketItem.market_slug,
                                        wager,
                                        draws: 1,
                                        selection: x.entry.bet,
                                        event_id: [x.rebet.eventId],
                                        market_option: x.market_option || 'normal', // Add market_option for rebet
                                    };
                                    bets.entries.push(item);
                                }
                            });
                            bets = [bets];

                            const resp = await LottoService.transactDaily(bets, respToken.data.token);
                            if (resp.status === 'success' && resp.code === 200) {
                                this.printLottoDaily(resp.data);
                                this.ticketNumber = ''
                            } else {
                                this.showNotification(resp.message, 'error');
                            }
                        } else {
                            this.showNotification(respGame.message, 'error');
                        }
                    } else {
                        this.showNotification(respRebet.message, 'error');
                    }
                } else {
                    this.showNotification(respToken.message, 'error');
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoadingButton = false;
            }
        },

        async onRebetTicket() {
            try {
                this.isLoadingButton = true;
                const respCheckRebet = await BetslipsService.checkRebetLoto(this.ticketNumber);

                if (respCheckRebet.code !== 200) {
                    this.showNotification(respCheckRebet.message, 'error');
                    this.isLoadingButton = false;
                    return false;
                }

                const param = await this.validateGetTicket();
                if (!isObjEmpty(param)) {
                    const { response } = param;
                    if (response.code !== 200) {
                        this.showNotification(response.message, 'error');
                        this.isLoadingButton = false;
                        return false;
                    }

                    if (this.$store.state.betSlip.okapiLottery) {
                        this.onTransactLotto(response.data.transaction.reference);
                    } else {
                        this.onTransactLottoDaily(response.data.transaction.reference);
                    }
                } else {
                    this.isLoadingButton = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async onRebetSports() {
            this.isLoadingButton = true;
            try {
                if (this.ticketNumber) {
                    const param = await this.validateGetTicket();
                    if (!this.isObjEmpty(param.response)) {
                        const { response } = param;
                        if (response.code !== 200) {
                            this.showNotification(response.message, 'error');
                            this.isLoadingButton = false;
                        } else {
                            const param = {
                                url: response.data.sport_url,
                                code: response.data.sport_code,
                                betId: response.data.sport_bet_id,
                                token: response.data.sport_token,
                            };
                            const respRebet = await BetslipsService.reBetSports(param);
                            if (respRebet.code === 200 || respRebet.status === 'success') {
                                this.printSports(respRebet.print_data);
                                this.isLoadingButton = false;
                            } else {
                                this.showNotification(respRebet.message, 'error');
                                this.isLoadingButton = false;
                            }
                        }
                    }
                    this.ticketNumber = '';
                }
            } catch (error) {
                this.isLoadingButton = false;
                console.log(error);
            }
        },

        async validateGetTicket() {
            this.isLoadingButton = true;
            let ticket = '';
            try {
                ticket = `${this.ticketType}-${this.ticketNumber}`;

                const response = await BetslipsService.searchBetslip(ticket);

                const param = {
                    response,
                    ticket,
                };
                return param;
            } catch (error) {
                console.log(error);
            }
        },

        onDecode(event) {
            const resp = JSON.parse(event.data);
            if (resp.command === 'on-decode-scan') {
                let value = resp.data;

                if (value.startsWith('L-') || value.startsWith('LI-')) {
                    value = resp.data?.split('-');
                    value = value[1] || value;
                    this.ticketNumber = value.replace(/L/g, '').replace(/-/g, '');
                    if (this.ticketType === 'L') {
                        this.isShowScan = false;
                    }
                    this.ticketType = 'L';
                    parent.postMessage({ command: 'is-show-cammera', param: false }, '*');
                } else if (value.startsWith('S-')) {
                    value = resp.data?.split('-');
                    value = value[1] || value;
                    this.ticketNumber = value.replace(/S/g, '').replace(/-/g, '');
                    if (this.ticketType === 'S') {
                        this.isShowScan = false;
                    }
                    this.ticketType = 'S';
                    parent.postMessage({ command: 'is-show-cammera', param: false }, '*');
                } else if (value.startsWith('N-')) {
                    value = resp.data?.split('-');
                    value = value[1] || value;
                    this.ticketNumber = value.replace(/N/g, '').replace(/-/g, '');
                    if (this.ticketType === 'N') {
                        this.isShowScan = false;
                    }
                    this.ticketType = 'N';
                    this.isShowRepay = false;
                    parent.postMessage({ command: 'is-show-cammera', param: false }, '*');
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/scan/scanTicket.scss';
</style>
